// extracted by mini-css-extract-plugin
export default {"delete":"RemoveItemButton-module__delete___xwb13"};